export const Name = 'Name';
export const Email = 'Email';
export const Role = 'Role';
export const Actions = 'Actions';
export const Add = 'Add';
export const Export = 'Export'


